<template>
  <div id="app" :dir="direction" style="unicode-bidi: bidi-override !important;">
    <WebLayout v-if="$auth.check() && $auth.token()" :key="incrementer">
      <template slot="layout">
        <router-view :key="$route.fullPath"/>
      </template>
    </WebLayout>

    <router-view v-else :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  components: {
    WebLayout: require('@/components/layouts/WebLayout').default
  },
  name: 'App',
  data() {
    return {
      incrementer: 0
    }
  },
  mounted () {
    this.checkAuthenticationReady(() => {
      this.changeStyleSheet(this.$auth.user().language)
      this.fetchData()
      setInterval(() => {
        this.$auth.fetch()
      }, 65 * 1000)
    })
  },
  methods: {
  }
}
</script>

<style>
.ui.modal {
  margin-top: -10% !important;
}

@media print {
  .no-print, .no-print * {
    display: none !important;
  }

  html, body {
    height: 100%;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue